import { useMemo } from 'react';
import { Column } from 'react-table';
import { tableColumns } from '@core/table';
import { IBoxTransferUser } from '../../interfaces';
import { boxTransfersQueryKeys } from '../../utils';
import { Tag } from 'antd';

export const useBoxTransfersTableColumns = () => {
  const baseColumns = useMemo<Column<IBoxTransferUser>[]>(
    () => [
      {
        ...tableColumns.small,
        accessor: (row) => row.id,
        id: boxTransfersQueryKeys.id,
        Header: 'Kod',
      },
      {
        ...tableColumns.normal,
        accessor: (row) => row.declaration.trackCode,
        id: boxTransfersQueryKeys.declaration.trackCode,
        Header: 'İzləmə kodu',
      },
      {
        ...tableColumns.normal,
        accessor: (row) => row.fromContainer.name,
        id: boxTransfersQueryKeys.fromContainer.name,
        Header: 'Yeşikdən',
      },
      {
        ...tableColumns.normal,
        accessor: (row) => row.toContainer.name,
        id: boxTransfersQueryKeys.toContainer.name,
        Header: 'Yeşiyə',
      },
      {
        ...tableColumns.large,
        accessor: (row) => row.branch.name,
        id: boxTransfersQueryKeys.branch.name,
        Header: 'Filial',
        Filter: () => null,
      },
      {
        ...tableColumns.large,
        accessor: (row) => row.user.name,
        id: boxTransfersQueryKeys.user.id,
        Header: 'İcraçı',
        Cell: ({ cell: { value }, row: { original } }) => <Tag>{`#${original.user.id} ${value}`}</Tag>,
      },
      {
        accessor: (row) => row.note,
        id: boxTransfersQueryKeys.note,
        Header: 'Qeyd',
      },
      {
        ...tableColumns.date,
        accessor: (row) => row.createdAt,
        id: boxTransfersQueryKeys.createdAt,
        Header: 'Tarix',
      },
    ],
    [],
  );

  return [...baseColumns];
};
